const en = {
  mainTitle: "Exam Registration",
  selectExam: "Select the exam",
  selectVenue: "Select the venue",
  selectModule: "Select the module",
  selectTestDate: "Please select your preferred test date",
  fillDetails: "Your details",
  residenceCountry: "Country of Residence",
  Other: "Other",
  Uzbekistan: "Uzbekistan",
  passportNo: "Passport or ID Number (e.g. AA1234567)",
  invalidPassportNo: "Please input a correct passport or ID number.",
  pinpp: "PINPP (14 digits)",
  invalidPinpp: "Please input a correct 14-digit PINPP.",
  pinppLookupError:
    "Unable to fetch information for the provided PINPP, please check",
  dob: "Date of Birth",
  wrongPassportOrDob: "Wrong Passport or Date of Birth, please check",
  proceed: "Continue",
  firstName: "First Name (per PASSPORT)",
  lastName: "Last Name (per PASSPORT)",
  gender: "Gender",
  male: "Male",
  female: "Female",
  selectCertificateRegion: "Select the region you get your certificate:",
  phoneNumber: "Phone Number (including 998)",
  invalidPhoneNumber: "Please input a correct phone number.",
  email: "Email",
  invalidEmail: "Please input a correct email.",
  attachPassport: "Attach the Passport",
  readAgreed: "I have read and agree to the ",
  termsConditions: "Terms & Conditions",
  submit: "SUBMIT",
  telephone: "Telephone",
  address1: "Address: 2-3 Bunyodkor Avenue, CIU Building 4th floor,",
  address2: "Tashkent, Uzbekistan 100043",
  submittedSucces: "You have successfully submitted your application with ",
  checkEmail: "Please, check your email to get further information.",
  payNow: "PAY NOW",
  contacts: "Contacts",
  results: "Results",
  examDates: "Exam Dates",
  whichTest: "Which test you're going to pay for?",
  examDate: "Exam Date",
  examDateRequired: "You need to select the exam date",
  examRegion: "Exam region",
  paymentFor: "Payment for",
  enterEnquiry: "Enter your EnquiryId number",
  next: "Next",
  examDetails: "Exam Details",
  date: "Date",
  region: "Region",
  status: "Status",
  examPrice: "Exam Price",
  processingFee: "Processing Fee",
  totalPay: "Total to Pay",
  price: "Price",
  cardNo: "Card Number",
  validThru: "Valid Thru",
  phoneNo: "Phone Number",
  enterCode: "Enter the code from the SMS",
  pay: "Pay",
  securePaymentTitle: "Secure Payment Processing:",
  securePayment1:
    "Your security is our priority. We do not store your card details. All payments are securely processed through",
  securePayment2:
    "a trusted third-party service. Enjoy peace of mind with end-to-end encryption and OTP verification for added security.",
  receipt: {
    title: "Payment Receipt",
    info: `LLC "Edu Action" Test Center confirms that the below candidate has successfully paid for the specified test and module:`,
    name: "Candidate Name",
    idNo: "ID/Passport No",
    paymentDate: "Payment Date",
    paymentAmount: "Payment Amount",
    exam: "Exam",
    module: "Module",
    qrInfo: `The QR code is proof to verify your payment.`,
  },
  selectProvider: "Choose how to pay",
  codeSent: "Code is sent to ",
  cvc: "CVV / CVC",
  cvcRequired: "Please enter the 3-digit code on the back of your card",
  promocode: "Promocode",
  promocodePlaceholder: "Enter your promocode",
  promocodeApply: "Apply",
  promocodeRemove: "Remove",
  promocodeApplied: "Promocode applied",
  promocodeInvalid: "This promocode cannot be used",
  promocodeOff: "off",
  promocodeDiscount: "Promocode Discount",
  promocodeSelectModule: "Please select what you are paying for first",
  menu: "Menu",
  backToTop: "Back to top",
  paymentFailedTitle: "Payment didn't go through",
  paymentFailedBody: "The payment wasn't completed. Check your card details and balance, then try again. If money was taken from your card, contact us.",
  tryAgain: "Try again",
  needHelp: "Need help?",
  notFoundTitle: "Page not found",
  notFoundBody: "The link may be old or mistyped.",
  goToPayment: "Go to the payment page",
  loadingReceipt: "Loading your receipt…",
  receiptNotFoundTitle: "Receipt not found",
  receiptNotFoundBody: "Check the link or QR code. If you have just paid, wait a minute and open the link again.",
  loadFailed: "Couldn't load the receipt",
  loadFailedBody: "Check your connection and try again.",
  print: "Print",
  selectPlaceholder: "Select…",
  clear: "Clear",
  intlCardTitle: "International cards (Visa, Mastercard)",
  invalidCardNumber: "Enter the full 16-digit card number.",
  invalidPhone9: "Enter the 9-digit phone number linked to your card.",
  otpRequired: "Enter the code from the SMS sent to your phone.",
  genericError: "Something went wrong. Please try again.",
  enquiryExpired: "This enquiry has expired and can no longer be paid. Contact us to get a new one.",
  enquiryRequired: "Enter your enquiry ID.",
  enquiryNotFound: "We couldn't find an enquiry with this ID. Check the number and try again.",
  instructions: "Instructions",
  checkAnotherEnquiry: "Check another enquiry",
  cardDetails: "Card details",
};

export default en;
